import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition, DealType } from "~/models/Deal";

type Props = {
	dealType: DealType;
	label: string;
};

export function DealTypeCheckBox({ dealType, label }: Props) {
	const { setValue, watch, getValues } = useFormContext<DealSearchCondition>();
	const watchedDealTypes = watch("dealTypes");

	const checked = useMemo((): boolean => {
		if (watchedDealTypes) {
			if (["restoration", "repair", "other"].includes(dealType)) {
				return watchedDealTypes.includes(dealType);
			}
		}
		return false;
	}, [watchedDealTypes, dealType]);

	const onDealTypeChange = useCallback((): void => {
		const dealTypes = [...(getValues("dealTypes") ?? [])];
		if (!checked) {
			// 追加
			if (!dealTypes.includes(dealType)) {
				dealTypes.push(dealType);
			}
		} else if (dealTypes.includes(dealType)) {
			// 削除
			dealTypes.splice(dealTypes.indexOf(dealType), 1);
		}
		setValue("dealTypes", dealTypes);
	}, [checked, dealType, getValues, setValue]);

	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={checked}
				label={label}
				onChange={onDealTypeChange}
			/>
		</Box>
	);
}
